import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { TextColor, TextVariant } from '../../constants/variants';

import * as s from './Text.module.scss';

const TAG_MAP = {
  [TextVariant.Display]: 'h1',
  [TextVariant.Title]: 'h2',
  [TextVariant.Heading]: 'h3',
  [TextVariant.Subheading]: 'h4',
  [TextVariant.Body]: 'p',
  [TextVariant.BodyLg]: 'p',
  [TextVariant.Caption]: 'span',
  [TextVariant.Label]: 'span',
  [TextVariant.Mono]: 'code',
};

const Text = React.memo(({ as, variant, color, weight, truncate, className, children, ...props }) => {
  const Component = as || TAG_MAP[variant] || 'span';

  return (
    <Component
      className={clsx(
        s.text,
        variant && s[variant],
        color && s[`color${color.charAt(0).toUpperCase()}${color.slice(1)}`],
        weight && s[`weight${weight.charAt(0).toUpperCase()}${weight.slice(1)}`],
        truncate && s.truncate,
        className,
      )}
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </Component>
  );
});

Text.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(Object.values(TextVariant)),
  color: PropTypes.oneOf(Object.values(TextColor)),
  weight: PropTypes.oneOf(['regular', 'medium', 'semibold', 'bold']),
  truncate: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

Text.defaultProps = {
  as: undefined,
  variant: TextVariant.Body,
  color: TextColor.Primary,
  weight: undefined,
  truncate: false,
  className: undefined,
  children: undefined,
};

export default Text;
